import { FC, useEffect, useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import ReactToPrint from 'react-to-print';

import styled from 'styled-components';
import { BiReset, BiUndo, BiPrinter } from 'react-icons/bi';
import Button from '../../Button';

interface IProps {
  coords: any;
  address: string|null;
}

const Buttons = styled.div`
  width: 120px;

  & > * {
    font-size: 26px;
    line-height: 26px;
  }
`;

const SearchBar = styled.div`
  width: 100%;
`;

const MapContainer = styled.div`
  // width: 600px;
  // height: 450px;
`;

const EditArea: FC<IProps> = ({ coords, address }) => {
  const { t } = useTranslation();
  const { kakao } = window;
  const [keyword, setKeyword] = useState('');
  const [searchTrigger, setSearchTrigger] = useState(false);
  let map: any = null;
  let prevPolygon: any = null;

  const printRef = useRef();

  useEffect(() => {
    setMap();
  }, [searchTrigger]);

  const setMap = () => {
    const container = document.querySelector('#map');
    const options = {
      center: new kakao.maps.LatLng('37.56642510458935', '126.97794052669803'),
      level: 5
    };
    try {
      map = new kakao.maps.Map(container, options);
    } catch (e) {
      alert(e);
    }

    // 확대/축소 컨트롤
    const zoomControl = new kakao.maps.ZoomControl();
    map.addControl(zoomControl, kakao.maps.ControlPosition.RIGHT);

    if (coords) renderPolygon(coords);
    if (address) renderMarker(address);

    // 지도 클릭
    kakao.maps.event.addListener(map, 'click', (mouseEvent: any) => {
      let coords: any = sessionStorage.getItem('coords');
      if (coords === null) coords = [];
      else coords = JSON.parse(coords); 

      const lat = mouseEvent.latLng.getLat();
      const lng = mouseEvent.latLng.getLng();
      coords.push({ lat, lng });
      renderPolygon(coords);
      sessionStorage.setItem('coords', JSON.stringify(coords));
    });

    // 지도 검색
    if (!keyword) return;
    const places = new kakao.maps.services.Places();
    places.keywordSearch(keyword, (data: any, status: any) => {
      if (status === kakao.maps.services.Status.OK) {
        const bounds = new kakao.maps.LatLngBounds();
        data.forEach((item: any) => bounds.extend(new kakao.maps.LatLng(item.y, item.x)));
        map.setBounds(bounds);
      }
    });
  }

  const renderPolygon = (coords: any) => {
    const path: any = [];
    coords.forEach((coord: any) => path.push(new kakao.maps.LatLng(coord.lat, coord.lng)));
    const polygon = new kakao.maps.Polygon({
      map,
      path,
      fillColor: '#CFE7FF',
      fillOpacity: 0.5
    });
    if (prevPolygon) prevPolygon.setMap(null);
    prevPolygon = polygon;
    polygon.setMap(map);
  }

  const renderMarker = (address: string) => {
    const geocoder = new kakao.maps.services.Geocoder();
    geocoder.addressSearch(address, (result: any, status: any) => {
      if (status === kakao.maps.services.Status.OK) {
        const position = new kakao.maps.LatLng(result[0].y, result[0].x);
        new kakao.maps.Marker({ map, position });
        map.setCenter(position);
      }
    });
  }

  const onReset = () => {
    if (prevPolygon) prevPolygon.setMap(null);
    sessionStorage.removeItem('coords');
  }

  const onUndo = () => {
    let coords: any = sessionStorage.getItem('coords');
    if (coords === null) return;
    else coords = JSON.parse(coords);

    coords.pop();
    renderPolygon(coords);
    sessionStorage.setItem('coords', JSON.stringify(coords));
  }

  const onSearch = () => {
    if (!keyword) return;
    setSearchTrigger(!searchTrigger);
  }

  return (
    <>
      <div className="flex">
        <Buttons>
          <BiReset
            className="mx-1 pointer"
            title="reset"
            onClick={onReset}
          />
          <BiUndo
            className="mr-1 pointer"
            title="undo"
            onClick={onUndo}
          />
          <ReactToPrint
            trigger={() => (
              <BiPrinter
                className="mr-1 pointer"
                title="print"
              />
            )}
            // @ts-ignore
            content={() => printRef.current}
            bodyClass="print"
          />
        </Buttons>
        <SearchBar className="row mb-2">
          <div className="col-9">
            <input
              type="text"
              className="form-control input-text"
              value={keyword}
              onChange={e => setKeyword(e.target.value)}
              onKeyPress={e => { if (e.key === 'Enter') onSearch() }}
            />
          </div>
          <div className="col-3">
            <Button
              className="btn-basic black w-100"
              onClick={onSearch}
              text={t('common.button.search')}
            />
          </div>
        </SearchBar>
      </div>
      
      <MapContainer
        id="map"
        // @ts-ignore
        ref={printRef}
        style={{
          width: window.innerWidth - 600,
          height: window.innerHeight - 300
        }}
      >
      </MapContainer>
    </>
  )
}

export default EditArea;
